export default __webpack_public_path__ + "static/media/DeepDesert.9f8139b1.jpg";